const header = "'Orbitron', sans-serif";
const body = "'Oswald', sans-serif";
const monospace = "'IBM Plex Mono', monospace";

export const fonts = {
  header,
  body,
  monospace,
};
